import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute } from "@tanstack/react-router";
import { RoutinesTab } from "@/features/employee/routines-tab";

export const Route = createFileRoute("/_app/_main/team/$employeeId/routines")({
  component: () => <RoutinesTab employeeId={Route.useParams().employeeId as Id<"employees">} />,
});
